import React from "react";
// 导入首页样式文件
import "./homepage.css";
// 导入各个组成部分组件
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Main from "./components/Main/Main";
import Footer from "./components/Footer/Footer";
import AutoLogout from "./components/Auth/AutoLogout";

// 首页组件：整合导航栏、主页内容、主要内容和页脚
const Homepage = () => {
  return (
    <>
      {/* 导航栏组件 */}
      <Navbar />
      {/* 首页顶部视频和展示区域 */}
      <Home />
      {/* 主要展示目的地或推荐行程区域 */}
      <Main />
      {/* 页脚区域，展示社交链接、版权信息等 */}
      <Footer />
        {/* 自动登出组件 */}
        <AutoLogout />
    </>
  );
};

export default Homepage;